import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import API_BASE_URL from '../utils/apiConfig';
import { useAuth } from '../contexts/AuthContext';
import { useLocation } from '../contexts/LocationContext';
import { getAuth, deleteUser, updateProfile } from "firebase/auth";
import { db } from '../firebase-config';
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  orderBy,
  getDocs,
  deleteDoc,
  updateDoc, // Added updateDoc
  writeBatch, // Added writeBatch for bulk updates
  onSnapshot,
} from 'firebase/firestore';
import { Link } from 'react-router-dom';
import PostNewsModal from '../components/postNewsModal'; 
import PostJobModal from '../components/PostJobModal';
import CreateAdModal from '../components/CreateAdModal';
import WeatherWidget from '../components/WeatherWidget';
import AdCard from '../components/AdCard';
import FollowersModal from '../components/FollowersModal';

import './PageStyles.css';
import './Profile.css'; 
// Assuming you'll create a new CSS file for tabs or add the styles to Profile.css

const Profile = () => {
  const { currentUser, firebaseUser, isAdmin, isBusiness } = useAuth();
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [activeTab, setActiveTab] = useState('news');
  const { locationName: contextLocationName } = useLocation();
  const [userProfile, setUserProfile] = useState(null);
  const [userPosts, setUserPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPosts, setLoadingPosts] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPost, setEditingPost] = useState(null);

  const [isEditingName, setIsEditingName] = useState(false);
  const [newName, setNewName] = useState('');
  const [updatingName, setUpdatingName] = useState(false);
  
  const [showFollowersModal, setShowFollowersModal] = useState(false);
  const [modalType, setModalType] = useState('followers'); // 'followers' or 'following'
  const [followRequests, setFollowRequests] = useState([]);

  // NEW STATES FOR JOB POSTS
  const [userJobPosts, setUserJobPosts] = useState([]);
  const [loadingJobPosts, setLoadingJobPosts] = useState(false);
  const [showEditJobModal, setShowEditJobModal] = useState(false);
  const [editingJobPost, setEditingJobPost] = useState(null);
  // --- NEW STATES FOR AD POSTS ---
  const [userAds, setUserAds] = useState([]);
  const [loadingAds, setLoadingAds] = useState(false);
  const [showEditAdModal, setShowEditAdModal] = useState(false);
  const [editingAd, setEditingAd] = useState(null);
  const [previewAd, setPreviewAd] = useState(null);
  // NEW STATE for Tab Management: 'news' or 'jobs'
  const [bankDetails, setBankDetails] = useState({ accountNo: '', ifsc: '', name: '', upiId: '' });
  const [savingBank, setSavingBank] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showPaymentSettings, setShowPaymentSettings] = useState(false);
  const [myWithdrawals, setMyWithdrawals] = useState([]);

  // --- EXISTING useEffect for User Profile ---
  // This ensures that job posts are only fetched *after* userProfile is confirmed.
  useEffect(() => {
    const fetchUserProfile = async () => {
      if (currentUser) {
        setLoading(true);
        try {
          const userDocRef = doc(db, 'users', currentUser.uid);
          const docSnap = await getDoc(userDocRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            setUserProfile(data);
            setNewName(data.name || ''); // Initialize edit field
          }
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      }
      setLoading(false);
    };

    fetchUserProfile();
}, [currentUser]);

useEffect(() => {
  if (!currentUser) return;
  const q = collection(db, 'users', currentUser.uid, 'followRequests');
  const unsubscribe = onSnapshot(q, (snap) => {
    setFollowRequests(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  });
  return () => unsubscribe();
}, [currentUser]);
const handleRespondRequest = async (followerId, action) => {
  try {
    const idToken = await firebaseUser.getIdToken(true);
    await axios.post(`https://api-5iacy4tfya-uc.a.run.app/respond-follow-request`, 
      { followerId, action },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    alert(`Request ${action === 'accept' ? 'accepted' : 'rejected'} successfully.`);
  } catch (err) {
    console.error(err);
    alert("Failed to respond to request.");
  }
};

// --- NEW FUNCTION: UPDATE NAME EVERYWHERE ---
  const handleUpdateName = async () => {
  if (!newName.trim() || newName === userProfile.name) {
    setIsEditingName(false);
    return;
  }

  setUpdatingName(true);
  try {
    const batch = writeBatch(db);
    const uid = firebaseUser.uid;

    // 1. Update the Firebase Auth Display Name (for the system)
      // We use 'firebaseUser' here because it's the official Firebase object
      await updateProfile(firebaseUser, { displayName: newName });

      // 2. Update the User Document in Firestore
      const userRef = doc(db, 'users', uid);
      batch.update(userRef, { name: newName });

        // 3. Update Name in all userNews posts
      // Note: Based on your screenshot, the field is "userName"
      const newsQ = query(collection(db, 'userNews'), where('userId', '==', uid));
      const newsSnap = await getDocs(newsQ);
      newsSnap.forEach((newsDoc) => {
        batch.update(newsDoc.ref, { 
            userName: newName,
            authorName: newName // Update both to be safe
        });
      });

      // 4. Update Name in all Jobs
      const jobsQ = query(collection(db, 'jobs'), where('userId', '==', uid));
      const jobsSnap = await getDocs(jobsQ);
      jobsSnap.forEach((jobDoc) => {
        batch.update(jobDoc.ref, { userName: newName });
      });

      // 5. Update Name in all Advertisements
      const adsQ = query(collection(db, 'advertisements'), where('userId', '==', uid));
      const adsSnap = await getDocs(adsQ);
      adsSnap.forEach((adDoc) => {
        batch.update(adDoc.ref, { sponsor: newName });
      });

      // COMMIT THE ENTIRE BATCH
      await batch.commit();

      // Update local state
      setUserProfile(prev => ({ ...prev, name: newName }));
      setIsEditingName(false);
      
      alert("Success! Name updated everywhere.");
      
      // RELOAD to refresh the context and NewsCards
      window.location.reload(); 

    } catch (error) {
      console.error("Error updating name:", error);
      if (error.code === 'permission-denied') {
          alert("Permission denied. Please check your Firestore Security Rules.");
      } else {
          alert("Failed to update name. See console for details.");
      }
    } finally {
      setUpdatingName(false);
    }
  };

  const handleUpgrade = async () => {
    if (window.confirm("Switch to Business Account?")) {
        setIsUpgrading(true);
        try {
            const idToken = await firebaseUser.getIdToken();
            await axios.post(`${API_BASE_URL}/upgrade-to-business`, {}, {
                headers: { Authorization: `Bearer ${idToken}` }
            });
            alert("Congratulations! You are now a Business Member.");
            // Update local context
            window.location.reload(); // Refresh to update all buttons/tabs
        } catch (e) {
            alert("Upgrade failed. Please try again.");
        } finally {
            setIsUpgrading(false);
        }
    }
};

  // Load existing bank details if they exist in the profile
  useEffect(() => {
    if (userProfile?.bankDetails) {
        setBankDetails(prev => ({ ...prev, ...userProfile.bankDetails }));
    }
}, [userProfile]);

  // FIX 3: Implement saveBankDetails
  const handleSaveBankDetails = async () => {
    // Basic validation: Either Bank details OR UPI ID must be present
    const hasBank = bankDetails.name && bankDetails.accountNo && bankDetails.ifsc;
    const hasUpi = bankDetails.upiId && bankDetails.upiId.includes('@');

    if (!hasBank && !hasUpi) {
        alert("Please provide either full Bank Details or a valid UPI ID.");
        return;
    }

    setSavingBank(true);
    try {
        const userRef = doc(db, 'users', currentUser.uid);
        await updateDoc(userRef, { bankDetails });
        alert("Payment details updated!");
    } catch (error) {
        alert("Failed to save.");
    } finally {
        setSavingBank(false);
    }
};

  const handleWithdraw = async () => {
    if (userProfile?.walletBalance < 10) {
      alert("Minimum withdrawal is ₹10");
      return;
    }
    if (!userProfile?.bankDetails) {
      alert("Please add bank details first");
      return;
    }
    
    try {
      const idToken = await firebaseUser.getIdToken();
      await axios.post(`${API_BASE_URL}/withdraw`, 
        { userId: currentUser.uid },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      alert("Withdrawal request submitted!");
    } catch (e) {
      console.error(e);
      alert(e.response?.data?.message || "Error processing withdrawal.");
    }
  };

  useEffect(() => {
  const fetchMyWithdrawals = async () => {
    if (!currentUser) return;
    try {
      const q = query(
        collection(db, "withdrawals"), 
        where("userId", "==", currentUser.uid), 
        orderBy("createdAt", "desc")
      );
      const snap = await getDocs(q);
      setMyWithdrawals(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("Error fetching history:", error);
      // If index is missing, try fetching without orderBy first to see if it works
      const simpleQ = query(collection(db, "withdrawals"), where("userId", "==", currentUser.uid));
      const simpleSnap = await getDocs(simpleQ);
      setMyWithdrawals(simpleSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
  };
  fetchMyWithdrawals();
}, [currentUser]);
  
  // --- EXISTING useEffect for News Posts ---
  useEffect(() => {
    const fetchUserPosts = async () => {
      if (currentUser) {
        setLoadingPosts(true);
        try {
          const q = query(
            collection(db, 'userNews'),
            where('userId', '==', currentUser.uid),
            orderBy('createdAt', 'desc')
          );
          const querySnapshot = await getDocs(q);
          const posts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setUserPosts(posts);
        } catch (error) {
          console.error("Error fetching user posts:", error);
        }
        setLoadingPosts(false);
      } else {
        setUserPosts([]);
      }
    };

    fetchUserPosts();
  }, [currentUser, showEditModal]); 

  // --- NEW useEffect for Job Posts ---
  useEffect(() => {
    const fetchUserJobPosts = async () => {
      if (currentUser) {
        setLoadingJobPosts(true);
        try {
          const q = query( 
            collection(db, 'jobs'),
            // *** FIX: Query by 'userId' which is currentUser.uid ***
            where('userId', '==', currentUser.uid), 
            orderBy('timestamp', 'desc') // Use timestamp if that is what you use for sorting
          );
          const querySnapshot = await getDocs(q);
          const jobs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setUserJobPosts(jobs);
        } catch (error) {
          console.error("Error fetching user job posts:", error);
        }
        setLoadingJobPosts(false);
      } else {
        setUserJobPosts([]);
      }
    };

    fetchUserJobPosts();
    // Re-run when currentUser changes or after editing/creating a job post
}, [currentUser, showEditJobModal]);
useEffect(() => {
    const fetchUserAds = async () => {
      if (currentUser) {
        setLoadingAds(true);
        try {
          const q = query(
            collection(db, 'advertisements'), // <-- CORRECT COLLECTION
            where('userId', '==', currentUser.uid),
            orderBy('createdAt', 'desc')
          );
          const querySnapshot = await getDocs(q);
          const ads = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setUserAds(ads);
        } catch (error) {
          console.error("Error fetching user ads:", error);
        }
        setLoadingAds(false);
      } else {
        setUserAds([]);
      }
    };

    fetchUserAds();
    // Re-run when currentUser changes or after editing/creating an ad
}, [currentUser, showEditAdModal]);

const handleDeleteAccount = async () => {
  const confirmation = window.confirm(
    "⚠️ PERMANENT ACTION: Are you sure you want to delete your account? This will permanently remove your profile and all your posts from our database. This cannot be undone."
  );

  if (confirmation) {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert("No user found. Please log in again.");
      return;
    }

    try {
      // 1. Delete user data from Firestore first (while we still have permission)
      const userDocRef = doc(db, 'users', user.uid);
      await deleteDoc(userDocRef);
      console.log("Firestore user data deleted.");

      // 2. Delete the Authentication account
      await deleteUser(user);
      
      alert("Your account and all associated data have been deleted successfully.");
      window.location.href = "/"; // Redirect to home/login
    } catch (error) {
      console.error("Deletion error:", error);
      
      if (error.code === 'auth/requires-recent-login') {
        alert("For security reasons, this action requires a recent login. Please log out, log back in, and try again immediately.");
      } else {
        alert("Error deleting account: " + error.message);
      }
    }
  }
};
  // --- EXISTING News Post Handlers ---
  const handleDeletePost = async (postId) => {
    if (window.confirm("Are you sure you want to delete this news post? This action cannot be undone.")) {
      try {
        await deleteDoc(doc(db, 'userNews', postId));
        setUserPosts(prevPosts => prevPosts.filter(post => post.id !== postId));
        alert("News post deleted successfully!");
      } catch (error) {
        console.error("Error deleting news post:", error);
        alert("Failed to delete news post. Please try again.");
      }
    }
  };

  const handleEditPost = (post) => {
    setEditingPost(post);
    setShowEditModal(true);
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingPost(null);
  };


  // --- NEW Job Post Handlers ---
  const handleDeleteJob = async (jobId) => {
    const confirmationMessage = 
    "Are you sure you want to delete this job post? \n\n" +
    "⚠️ WARNING: If this was a paid post, the payment is NON-REFUNDABLE. " +
    "The amount will not be returned even if you delete the post now.";
    if (window.confirm(confirmationMessage)) {
      try {
        await deleteDoc(doc(db, 'jobs', jobId));
        setUserJobPosts(prevJobs => prevJobs.filter(job => job.id !== jobId));
        alert("Job post deleted successfully!");
      } catch (error) {
        console.error("Error deleting job post:", error);
        alert("Failed to delete job post. Please try again.");
      }
    }
  };

  const handleEditJob = (job) => {
    setEditingJobPost(job);
    setShowEditJobModal(true);
  };

  const handleCloseJobModal = () => {
    setShowEditJobModal(false);
    setEditingJobPost(null);
  };
  const handleDeleteAd = async (adId) => {
    // --- CRITICAL NEW CONFIRMATION MESSAGE ---
    const confirmationMessage = 
        "Are you sure you want to delete this ad? \n\n" +
        "⚠️ WARNING: The payment for this ad is NON-REFUNDABLE. " +
        "The paid amount will NOT be returned, even if you delete the ad now.";
        
    if (window.confirm(confirmationMessage)) {
      try {
        await deleteDoc(doc(db, 'advertisements', adId));
        setUserAds(prevAds => prevAds.filter(ad => ad.id !== adId));
        alert("Ad deleted successfully! The payment remains non-refundable.");
      } catch (error) {
        console.error("Error deleting ad:", error);
        alert("Failed to delete ad. Please try again.");
      }
    }
  };

  const handleEditAd = (ad) => {
    // Pass the existing ad data to the modal
    setEditingAd(ad);
    setShowEditAdModal(true);
  };

  // This will be called when the ad modal successfully posts the update
  const handleCloseAdModal = () => {
    setShowEditAdModal(false);
    setEditingAd(null);
    // Optionally refetch ads to update the list, or rely on useEffect's dependency
    // fetchUserAds(); // A direct refetch is faster than waiting for useEffect
  };

  if (loading) {
    return <div className="page-container"><h1>Loading Profile...</h1></div>;
  }
  
  const displayLocation = contextLocationName || userProfile?.location;

  // NEW: Render function for News Posts
  const renderNewsPosts = () => {
    if (loadingPosts) {
      return <p>Loading your news posts...</p>;
    }
    if (userPosts.length === 0) {
      return <p>You haven't posted any news yet.</p>;
    }
    return (
      <div className="posts-grid">
        {userPosts.map((post) => (
          <div key={post.id} className="post-card">
            <h3>{post.title}</h3>
            <p className="post-content-snippet">{post.content.substring(0, 100)}{post.content.length > 100 ? '...' : ''}</p>
             {/* --- RENDER IMAGE --- */}
          {post.imageUrls && post.imageUrls.length > 0 && (
            <div className="post-image-preview">
              <img src={post.imageUrls[0]} alt="News" />
            </div>
          )}

          {/* --- ADD RENDER VIDEO --- */}
          {post.videoUrl && (
            <div className="post-video-preview" style={{ width: '100%', maxHeight: '200px', overflow: 'hidden', backgroundColor: '#000', borderRadius: '5px', marginTop: '10px' }}>
              <video src={post.videoUrl} controls style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }} />
            </div>
          )}
            <div className="post-meta">
              <span>Status: <span className={`post-status ${post.status}`}>{post.status}</span></span>
              <span>Type: {post.postType}</span>
            </div>
            {/* --- ADD REJECTION REASON HERE --- */}
            {post.status === 'rejected' && post.rejectionReason && (
              <div className="rejection-box" style={{ 
                marginTop: '10px', 
                padding: '8px', 
                background: '#fff5f5', 
                borderLeft: '4px solid #fc8181',
                fontSize: '13px',
                color: '#c53030'
              }}>
                <strong>Rejection Reason:</strong> {post.rejectionReason}
              </div>
            )}
            <div className="post-actions">
              <button onClick={() => handleEditPost(post)} className="edit-post-button">Edit</button>
              <button onClick={() => handleDeletePost(post.id)} className="delete-post-button">Delete</button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // NEW: Render function for Job Posts
  const renderJobPosts = () => {
    if (loadingJobPosts) {
      return <p>Loading your job posts...</p>;
    }
    if (userJobPosts.length === 0) {
      return <p>You haven't posted any jobs yet.</p>;
    }
    return (
      <div className="posts-grid">
        {userJobPosts.map((job) => (
          <div key={job.id} className="post-card job-card">
            <h3>{job.title} ({job.jobType.charAt(0).toUpperCase() + job.jobType.slice(1)} Job)</h3>
            <p><strong>Role:</strong> {job.jobRole || 'N/A'}</p>
            <p><strong>Company:</strong> {job.companyName || 'Government'}</p>
            <p><strong>Location:</strong> {job.locationDistrict ? `${job.locationDistrict}, ` : ''}{job.locationState}</p>
            <p className="post-content-snippet"><strong>Description:</strong> {job.description?.substring(0, 100)}{job.description?.length > 100 ? '...' : ''}</p>
            <div className="post-meta">
              <span>Status: <span className={`post-status ${job.status || 'pending'}`}>{job.status || 'Pending'}</span></span>
              <span>Type: {job.jobType}</span>
              <span>Last Date: {job.lastDate || 'N/A'}</span>
            </div>
            <div className="post-actions">
              <button onClick={() => handleEditJob(job)} className="edit-post-button">Edit Details (Free)</button>
              {/* If you want a separate Repost button for payment, you can add it here */}
              <button onClick={() => handleDeleteJob(job.id)} className="delete-post-button">Delete</button>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const renderAdsPosts = () => {
    if (loadingAds) {
      return <p>Loading your advertisements...</p>;
    }
    if (userAds.length === 0) {
      return <p>You haven't posted any advertisements yet.</p>;
    }
    return (
      <div className="posts-grid">
        {userAds.map((ad) => {
            // Force first frame for video preview
            const isVid = !!ad.videoUrl;
            // Calculate a simple engagement score (Views per day)
            const views = ad.viewCount || 0;
            return (
                <div key={ad.id} className="post-card ad-card" onClick={() => setPreviewAd(ad)} style={{ cursor: 'pointer' }}>
                    <div className="ad-preview-container" style={{ width: '100px', height: '130px', background: '#000', overflow: 'hidden', position: 'relative' }}>
              {isVid ? (
                <video 
                  src={`${ad.videoUrl}#t=0.001`} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                  muted 
                  playsInline
                  preload="metadata"
                />
              ) : (
                            <img 
                                src={ad.imageUrls?.[0] || ad.imageUrl} 
                                alt="Ad Preview" 
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            />
                        )}
                        <span className="media-type-tag" style={{ position: 'absolute', bottom: '5px', left: '5px' }}>
                            {isVid ? 'Video' : 'Image'}
                        </span>
                    </div>
                    <div className="ad-info-body" style={{padding: '10px', flex: 1}}>
                      <h3 style={{fontSize: '14px', margin: '0 0 5px 0', color: '#333'}}>{ad.title}</h3>
                      {/* --- ANALYTICS SECTION --- */}
                      <div className="ad-analytics" style={{ 
                        background: '#f0f7ff', 
                        padding: '8px', 
                        borderRadius: '5px', 
                        marginBottom: '10px',
                        border: '1px solid #d1e3ff'
                      }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#0056b3' }}>
                            👁️ Total Views: {views}
                          </span>
                          <span style={{ fontSize: '12px', color: '#28a745' }}>
                            Active Reach
                          </span>
                        </div>
                        <div className="progress-bar-bg" style={{ height: '6px', background: '#e0e0e0', borderRadius: '3px', marginTop: '5px' }}>
                          <div style={{ 
                            width: `${Math.min(views/10, 100)}%`, // Example visualization
                            height: '100%', 
                            background: '#007bff', 
                            borderRadius: '3px' 
                          }}></div>
                        </div>
                      </div>
                      <div style={{fontSize: '12px', color: '#666'}}>
                        <div>Status: <span className={`post-status ${ad.isActive ? 'approved' : 'rejected'}`}>{ad.isActive ? 'Active' : 'Expired'}</span></div>
                        <div>Expiry: {ad.expiryDate ? new Date(ad.expiryDate.toDate()).toLocaleDateString() : 'N/A'}</div>
                      </div>
                    </div>
                    <div className="post-actions" onClick={(e) => e.stopPropagation()}>
                      <button onClick={() => handleEditAd(ad)} className="edit-post-button">Edit</button>
                      <button onClick={() => handleDeleteAd(ad.id)} className="delete-post-button">Delete</button>
                    </div>
                </div>
            );
        })}

        {/* 3. Add the Modal Overlay to show the Full AdCard */}
        {previewAd && ReactDOM.createPortal(
            <div className="modal-overlay" onClick={() => setPreviewAd(null)} style={{ zIndex: 10000 }}>
                <div className="modal-content" onClick={e => e.stopPropagation()} style={{ background: 'transparent', boxShadow: 'none', width: '95%', maxWidth: '450px' }}>
                    <button onClick={() => setPreviewAd(null)} style={{ position: 'absolute', top: '-40px', right: '0', background: 'none', border: 'none', color: 'white', fontSize: '30px' }}>&times;</button>
                    {/* We pass the data into the REAL AdCard component */}
                    <AdCard adData={previewAd} />
                    <p style={{ color: 'white', textAlign: 'center', marginTop: '10px' }}>Full Ad Preview</p>
                </div>
            </div>,
            document.body
        )}
      </div>
    );
};

  return (
    <div className="page-container">
      <h1>My Profile</h1>
      {currentUser ? (
        <div className="profile-details">
          {/* ... Profile Info Section ... */}
          <div className="profile-item">
            <strong>Email:</strong>
            <span>{currentUser.email}</span>
          </div>

          {/* --- MODIFIED NAME SECTION --- */}
          <div className="profile-item name-edit-section">
            <strong>Name:</strong>
            {isEditingName ? (
              <div className="edit-name-input-group">
                <input 
                  type="text" 
                  value={newName} 
                  onChange={(e) => setNewName(e.target.value)}
                  className="edit-name-input"
                  disabled={updatingName}
                />
                <button onClick={handleUpdateName} className="save-name-btn" disabled={updatingName}>
                  {updatingName ? 'Saving...' : 'Save'}
                </button>
                <button onClick={() => setIsEditingName(false)} className="cancel-name-btn" disabled={updatingName}>
                  Cancel
                </button>
              </div>
            ) : (
              <div className="display-name-group">
                <span>{userProfile?.name || 'Set your name'}</span>
                <button onClick={() => setIsEditingName(true)} className="edit-icon-btn">
                   Edit
                </button>
              </div>
            )}
          </div>

          {/* Follow Statistics Row */}
<div className="profile-social-stats">
  <div className="stat-box" onClick={() => { setModalType('followers'); setShowFollowersModal(true); }}>
    <span className="stat-count">{userProfile?.followersCount || 0}</span>
    <span className="stat-label">Followers</span>
  </div>
  <div className="stat-box" onClick={() => { setModalType('following'); setShowFollowersModal(true); }}>
    <span className="stat-count">{userProfile?.followingCount || 0}</span>
    <span className="stat-label">Following</span>
  </div>
</div>
          
          <div className="profile-item">
            <strong>Phone Number:</strong>
            <span>{userProfile?.phoneNumber || 'Not provided'}</span>
          </div>

          <div className="profile-item">
            <strong>Detected Location:</strong>
            <span>
              {displayLocation
                ? `${displayLocation.city}, ${displayLocation.state}`
                : 'Location not yet saved. Allow access on the homepage.'
              }
            </span>
          </div>
          {/* --- PENDING FOLLOW REQUESTS ACCORDION --- */}
{followRequests.length > 0 && (
  <div className="accordion-wrapper" style={{ marginTop: '15px', marginBottom: '15px' }}>
    <button 
      className="accordion-header" 
      onClick={() => setShowWithdraw(!showWithdraw)} // Reuses or replaces toggle state, e.g., using a dedicated state like [showRequests, setShowRequests]
      style={{ background: '#fffbeb', border: '1px solid #fce8b2' }}
    >
      <span style={{ color: '#b45309', fontWeight: 'bold' }}>👤 Pending Follow Requests ({followRequests.length})</span>
      <span className={`arrow ${showWithdraw ? 'open' : ''}`} style={{ color: '#b45309' }}>▼</span>
    </button>
    {showWithdraw && (
      <div className="accordion-content" style={{ padding: '12px', background: '#ffffff', border: '1px solid #fce8b2', borderTop: 'none', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {followRequests.map(req => (
            <div key={req.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffffff', padding: '10px 14px', borderRadius: '8px', border: '1px solid #fce8b2' }}>
              
              {/* Clicking the name now navigates safely to their public profile */}
              <Link 
                to={`/user/${req.followerId}`} 
                style={{ fontWeight: '600', color: '#007bff', textDecoration: 'none' }}
              >
                {req.name || 'Ai News User'}
              </Link>
              
              <div style={{ display: 'flex', gap: '8px' }}>
                <button 
                  onClick={() => handleRespondRequest(req.id, 'accept')} 
                  className="button-primary"
                  style={{ padding: '6px 12px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}
                >
                  Accept
                </button>
                <button 
                  onClick={() => handleRespondRequest(req.id, 'reject')} 
                  style={{ padding: '6px 12px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}
                >
                  Reject
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
)}
          {/* --- ADD WEATHER WIDGET HERE --- */}
          {displayLocation && displayLocation.city && (
            <WeatherWidget location={displayLocation} />
          )}

          {!isBusiness && !isAdmin && (
    <div className="upgrade-business-banner" style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
        color: 'white', padding: '20px', borderRadius: '10px', marginBottom: '20px' 
    }}>
        <h3>🚀 Grow with Ai News</h3>
        <p>Want to hire employees or promote your business? Switch to a Business Account for free!</p>
        <button onClick={handleUpgrade} disabled={isUpgrading} className="save-name-btn" style={{ background: 'white', color: '#764ba2' }}>
            {isUpgrading ? 'Processing...' : 'Switch to Business Account'}
        </button>
    </div>
)}

          {/* --- WALLET SECTION --- */}
          <div className="wallet-section" style={{ padding: '20px', background: '#f8f9fa', marginTop: '20px', borderRadius: '10px', border: '1px solid #ddd' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <h3 style={{ margin: 0 }}>💰 Earnings</h3>
    <div style={{ textAlign: 'right' }}>
      <div style={{ background: '#e3f2fd', padding: '4px 10px', borderRadius: '15px', fontSize: '11px', fontWeight: 'bold', color: '#1976d2', border: '1px solid #90caf9' }}>
        {/* Updated Text: 1 post = ₹0.10 */}
        Earn ₹0.10 per Approved News
      </div>
    </div>
  </div>

  <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div>
      <span style={{ fontSize: '12px', color: '#666' }}>Balance</span>
      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#2e7d32' }}>₹{userProfile?.walletBalance || 0}</div>
      <div style={{ fontSize: '13px', color: '#ef6c00', fontWeight: '500', marginTop: '5px' }}>
        <i className="fas fa-clock"></i> Pending Conversion: 
        {/* Math: 1 coin = 0.05 rupees (because 2 coins = 0.10) */}
        ₹{(userProfile?.coins * 0.05).toFixed(2)} 
        <small style={{ color: '#888', fontWeight: 'normal', marginLeft: '5px' }}>
          ({Math.floor((200 - (userProfile?.coins || 0)) / 2)} more posts to convert)
        </small>
      </div>
    </div>
    <button 
      className="button-primary" 
      onClick={handleWithdraw} 
      disabled={(userProfile?.walletBalance || 0) < 10}
    >
      Withdraw
    </button>
  </div>
  
  <p style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
    * Automatic conversion happens every 100 posts (₹10). Minimum withdrawal: ₹10.
  </p>
  </div>

  {/* 3. PAYMENT SETTINGS DROPDOWN */}
          <div className="accordion-wrapper" style={{ marginTop: '15px' }}>
            <button className="accordion-header" onClick={() => setShowPaymentSettings(!showPaymentSettings)}>
              <span>⚙️ Payment Settings (Bank/UPI)</span>
              <span className={`arrow ${showPaymentSettings ? 'open' : ''}`}>▼</span>
            </button>
            {showPaymentSettings && (
              <div className="accordion-content payment-form-box">
                <label className="input-label">UPI ID (Recommended)</label>
                <input className="form-input" placeholder="example@upi" value={bankDetails.upiId} onChange={(e) => setBankDetails({...bankDetails, upiId: e.target.value})} />
                
                <div className="bank-divider"><span>OR BANK DETAILS</span></div>
                
                <input className="form-input" placeholder="Account Holder Name" value={bankDetails.name} onChange={(e) => setBankDetails({...bankDetails, name: e.target.value})} />
                <input className="form-input" placeholder="Account Number" value={bankDetails.accountNo} onChange={(e) => setBankDetails({...bankDetails, accountNo: e.target.value})} />
                <input className="form-input" placeholder="IFSC Code" value={bankDetails.ifsc} onChange={(e) => setBankDetails({...bankDetails, ifsc: e.target.value})} />
                
                <button onClick={handleSaveBankDetails} className="save-payment-btn">
                  {savingBank ? 'Saving...' : 'Save Payment Details'}
                </button>
              </div>
            )}
          </div>

          {/* 4. WITHDRAWAL HISTORY DROPDOWN (RESTORED STYLING) */}
          <div className="accordion-wrapper" style={{ marginTop: '10px' }}>
            <button className="accordion-header" onClick={() => setShowHistory(!showHistory)}>
              <span>📜 Recent Withdrawals ({myWithdrawals?.length || 0})</span>
              <span className={`arrow ${showHistory ? 'open' : ''}`}>▼</span>
            </button>
            {showHistory && (
              <div className="withdrawal-history" style={{ borderTop: '1px solid #eee', background: '#fff' }}>
                {myWithdrawals.length === 0 ? (
                  <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>No withdrawal history yet.</p>
                ) : (
                  myWithdrawals.map(w => (
                    <div key={w.id} className="history-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
                      <div>
                        <strong style={{ display: 'block', fontSize: '16px', color: '#333' }}>₹{w.amount}</strong>
                        <small style={{ color: '#888' }}>
                          {w.createdAt?.seconds ? new Date(w.createdAt.seconds * 1000).toLocaleDateString() : 'Processing...'}
                        </small>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <span className={`status-pill ${w.status}`} style={{ 
                            padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold', textTransform: 'uppercase',
                            backgroundColor: w.status === 'completed' ? '#e8f5e9' : w.status === 'pending' ? '#fff3e0' : '#ffebee',
                            color: w.status === 'completed' ? '#2e7d32' : w.status === 'pending' ? '#ef6c00' : '#c62828'
                        }}>
                          {w.status}
                        </span>
                        {w.transactionId && <small style={{ display: 'block', color: '#888', fontSize: '10px', marginTop: '2px' }}>ID: {w.transactionId}</small>}
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        {(isBusiness || isAdmin) && (
          <Link to="/post-ad" className="profile-action-button primary-btn"> 
            📢 Post Advertisement
          </Link>
          )}
          
          <div className="user-posts-container">
            {/* Tab Headers */}
            <div className="tabs-header">
              <button 
                className={`tab-button ${activeTab === 'news' ? 'active' : ''}`}
                onClick={() => setActiveTab('news')}
              >
                My News Posts
              </button>
              {(isBusiness || isAdmin) && (
                <>
              <button 
                className={`tab-button ${activeTab === 'jobs' ? 'active' : ''}`}
                onClick={() => setActiveTab('jobs')}
              >
                My Job Posts
              </button>
              <button 
                className={`tab-button ${activeTab === 'ads' ? 'active' : ''}`}
                onClick={() => setActiveTab('ads')}
              >
                My Advertisements
              </button>
              </>
              )}
            </div>

            {/* Tab Content */}
            <div className="tabs-content">
              {activeTab === 'news' && (
                <div className="user-posts-section">
                  {renderNewsPosts()}
                </div>
              )}
              {(isBusiness || isAdmin) && activeTab === 'jobs' && (
                <div className="user-posts-section">
                  {renderJobPosts()}
                </div>
              )}
              {(isBusiness || isAdmin) && activeTab === 'ads' && (
                <div className="user-posts-section">
                  {renderAdsPosts()}
                </div>
              )}
            </div>
          </div>
          <div style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
    <button 
      onClick={handleDeleteAccount} 
      className="delete-post-button" 
      style={{ width: '100%', backgroundColor: '#dc3545', color: 'white', padding: '10px', borderRadius: '5px', border: 'none' }}
    >
      Delete My Account & Data
    </button>
    <p style={{ fontSize: '12px', color: '#777', marginTop: '10px', textAlign: 'center' }}>
      Note: Deleting your account permanently removes your profile and all user-generated content from our database.
    </p>
  </div>
        </div>
      ) : (
        <p>Please log in to view your profile.</p>
      )}

      {showEditModal && (
        <PostNewsModal
          onClose={handleCloseModal}
          initialPostData={editingPost}
          isEditing={!!editingPost}
        />
      )}

      {(isBusiness || isAdmin) && showEditJobModal && (
        <PostJobModal
          onClose={handleCloseJobModal}
          initialJobData={editingJobPost}
          isEditing={!!editingJobPost}
        />
      )}
      {(isBusiness || isAdmin) && showEditAdModal && (
        <CreateAdModal
          onClose={handleCloseAdModal}
          initialData={editingAd} // <-- Pass the existing ad data
          // NOTE: CreateAdModal needs to be updated to handle the 'initialData' prop for editing.
        />
      )}
      {showFollowersModal && (
        <FollowersModal
          userId={currentUser.uid}
          type={modalType}
          onClose={() => setShowFollowersModal(false)}
        />
      )}
    </div>
  );
};

export default Profile;